const summary_cards = [
  { label: 'Record categories', value: '6', note: 'On the schedule', accent: 'dark' },
  { label: 'Compliant', value: '3', note: 'Within retention', accent: 'green' },
  { label: 'Legal holds', value: '1', note: 'Disposal suspended', accent: 'amber' },
  { label: 'Disposal due', value: '2', note: 'Action needed', accent: 'red' }
];

const filters = [
  { label: 'All 6', active: true },
  { label: 'Finance 3', active: false },
  { label: 'HR & people 2', active: false },
  { label: 'Privacy 1', active: false }
];

const rows = [
  { ref: 'RR-01', category: 'Supplier & contract records', retention: '5 years after contract close', owner: 'Records Manager', legal_hold: 'No', disposal: '12 due for review', status: { label: 'Review due', class: 'bg-warning-subtle text-warning-emphasis' } },
  { ref: 'RR-02', category: 'Employee personal data', retention: 'Employment + 5 years (POPIA)', owner: 'HR Manager', legal_hold: 'No', disposal: 'None due', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' } },
  { ref: 'RR-03', category: 'Financial records & AFS', retention: '7 years (Companies Act)', owner: 'CFO office', legal_hold: 'No', disposal: 'None due', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' } },
  { ref: 'RR-04', category: 'Procurement & bid records', retention: '5 years', owner: 'SCM Manager', legal_hold: 'Hold', disposal: 'Held', status: { label: 'Legal hold', class: 'bg-warning-subtle text-warning-emphasis' } },
  { ref: 'RR-05', category: 'Board & committee minutes', retention: 'Permanent', owner: 'Company Secretary', legal_hold: 'No', disposal: 'Never', status: { label: 'Compliant', class: 'bg-success-subtle text-success-emphasis' } },
  { ref: 'RR-06', category: 'CCTV & access logs', retention: '12 months', owner: 'IT Security', legal_hold: 'No', disposal: '3 sets overdue', status: { label: 'Disposal due', class: 'bg-danger-subtle text-danger-emphasis' } }
];

export default {
  name: 'ComplyonRecordsRetention',
  data: () => ({
    summary_cards,
    filters,
    rows
  })
};
